/** 旧系统合同交接「新客户类型」枚举。 */
/** 旧系统合同交接“新客户类型”枚举。 */
export const customerNoveltyTypeOptions = [
  "老客户",
  "新老师",
  "新系/专业",
  "新学校/学院",
];

/** 旧系统合同交接「合同类型」枚举。 */
export const contractTemplateTypeOptions = [
  "花儿旅行社旅游局合同1",
  "旅文化合同1",
  "四川蜀地合同1",
  "行艺道美合同1",
  "地接社合同1",
  "花儿线上合同2",
  "旅文化合同2",
  "四川蜀地合同2",
  "行艺道美合同2",
  "地接社合同2",
  "红柳1",
  "海南梭梭树1",
  "旅文化西安分公司1",
];

export type ContractCollectionAccountProfile = {
  contract: string;
  contractVersion: string;
  collectionAccount: string;
  remarkList: readonly string[];
  invoice: string;
};

/** 旧系统合同版本对应收款账户与发票口径，迁入订单交接模块内维护。 */
export const contractCollectionAccountProfiles = [
  {
    contract: "1号合同",
    contractVersion: "花儿旅行社旅游局合同1",
    collectionAccount: "花儿旅行社公账",
    remarkList: [
      "（1）【优先使用】单位名称：重庆花儿旅行社有限责任公司  单位账号：1239 0743 9910 201   开户行：招商银行重庆北部新区支行",
      "（2）花儿旅行社企业支付宝",
      "（3）商家收款码",
      "（4）何鸿鹄法人卡",
    ],
    invoice: "花儿旅行社发票要求",
  },
  {
    contract: "1号合同",
    contractVersion: "旅文化合同1",
    collectionAccount: "旅文化公账",
    remarkList: [
      "（1）【优先使用】单位名称：重庆市花儿旅文化艺术传播有限责任公司  单位账号：1116 3726 0885  开户行地址：中国银行重庆两江分行爱都会支行",
      "（2）旅文化企业支付宝",
      "（3）何鸿鹄法人卡",
    ],
    invoice: "旅文化合同发票要求",
  },
  {
    contract: "1号合同",
    contractVersion: "四川蜀地合同1",
    collectionAccount: "四川蜀地公账",
    remarkList: [
      "单位名称：四川蜀地写生文化艺术有限责任公司",
      "开户行：中国邮政储蓄银行茂县支行",
      "单位账号：9510 0401 0015 8489 00",
    ],
    invoice: "四川蜀地合同发票要求",
  },
  {
    contract: "1号合同",
    contractVersion: "行艺道美合同1",
    collectionAccount: "行艺道美公账",
    remarkList: [
      "单位名称：重庆行艺道美研学文化艺术交流有限公司",
      "开户行：招商银行股份有限公司重庆北部新区支行",
      "单位账号：1239 1174 4210 201",
    ],
    invoice: "行艺道美合同发票要求",
  },
  {
    contract: "1号合同",
    contractVersion: "地接社合同1",
    collectionAccount: "地接社公账",
    remarkList: ["由具体合作地接社提供"],
    invoice: "地接社合同发票要求",
  },
  {
    contract: "2号合同",
    contractVersion: "花儿线上合同2",
    collectionAccount: "花儿-2号账户",
    remarkList: ["蓝津招行/蓝津微信/蓝津支付宝/连洁交行 （详情见公司公布的收款账户）"],
    invoice: "花儿旅行社发票要求",
  },
  {
    contract: "2号合同",
    contractVersion: "旅文化合同2",
    collectionAccount: "花儿-2号账户",
    remarkList: ["蓝津招行/蓝津微信/蓝津支付宝/连洁交行 （详情见公司公布的收款账户）"],
    invoice: "旅文化合同发票要求",
  },
  {
    contract: "2号合同",
    contractVersion: "四川蜀地合同2",
    collectionAccount: "花儿-2号账户",
    remarkList: ["蓝津招行/蓝津微信/蓝津支付宝/连洁交行 （详情见公司公布的收款账户）"],
    invoice: "四川蜀地合同发票要求",
  },
  {
    contract: "2号合同",
    contractVersion: "行艺道美合同2",
    collectionAccount: "花儿-2号账户",
    remarkList: ["蓝津招行/蓝津微信/蓝津支付宝/连洁交行 （详情见公司公布的收款账户）"],
    invoice: "行艺道美合同发票要求",
  },
  {
    contract: "外部合同",
    contractVersion: "地接社合同2",
    collectionAccount: "地接社-2号账户",
    remarkList: ["由具体合作地接社提供"],
    invoice: "地接社发票要求",
  },
] as const satisfies readonly ContractCollectionAccountProfile[];

/** 按合同版本读取旧系统收款账户与发票口径配置。 */
export function getContractCollectionAccountProfile(
  contractVersion?: string,
): ContractCollectionAccountProfile | undefined {
  const normalizedVersion = contractVersion?.trim();
  if (!normalizedVersion) {
    return undefined;
  }
  return contractCollectionAccountProfiles.find((item) => item.contractVersion === normalizedVersion);
}

/** 构造旧系统收款账户多行文本。 */
export function buildContractReceivingAccountText(contractVersion?: string): string | undefined {
  return getContractCollectionAccountProfile(contractVersion)?.remarkList.join("\n");
}

/** 读取合同版本对应的发票标题，旧系统无配置时保持默认标题。 */
export function getContractInvoiceLabel(contractVersion?: string): string {
  return getContractCollectionAccountProfile(contractVersion)?.invoice ?? "发票要求";
}

/** 旧系统合同交接「签团机制」枚举。 */
export const signTeamStyleOptions = ["正常", "取消营业税", "抢团机制"];

/** 出行人员名单标准模板下载文件名。 */
export const rosterStandardTemplateFileName = "出行人员名单标准模板.csv";

/** 出行人员名单标准模板固定列名。 */
export const rosterStandardTemplateHeaders = [
  "姓名",
  "证件号",
  "电话",
  "专业/班级类型",
  "职务/职位",
  "应收金额",
  "火车硬座硬卧",
  "特殊情况",
  "学号",
  "人员类型",
  "年龄",
  "性别",
  "生日",
  "主签合同人地址",
] as const;

/** 出行名单旧系统兼容导出/编辑列名。 */
export const rosterLegacyHeaders = [
  "姓名",
  "证件号",
  "电话",
  "专业、班级类型",
  "职务",
  "应收金额",
  "大交通说明",
  "特殊情况",
  "学号",
  "人员类型",
  "年龄",
  "性别",
  "生日",
  "主签合同人地址",
  "证件类型",
  "住宿安排",
  "交通类型",
  "车辆分配",
  "线路金额",
  "备注",
] as const;
